module.exports = __webpack_public_path__ + "84a8c365a9d6e4c3814e405b7bcafbfe.svg";